import { Component, computed, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { ConfirmDialogComponent } from '@app/components/_common/confirm-dialog/confirm-dialog.component';
import { Evaluation } from '@app/models/enseignant';
import { SnackbarService } from '@app/services';
import { EnseignantService } from '@app/services/enseignant.service';

@Component({
  standalone: false,
  selector: 'app-evaluation-card-view',
  templateUrl: './evaluation-card-view.component.html',
  styleUrl: './evaluation-card-view.component.scss'
})
export class EvaluationCardViewComponent {

  evaluations = input<Evaluation[]>();
  idEnseignant = input<number>();
  totalItems = input<number>();
  pageSize = input<number>();
  pageIndex = input<number>();
  pageSizeOptions = input<number[]>();
  deleteEvaluation = output<number>();
  pageChange = output<PageEvent>();

  enseignantService = inject(EnseignantService);
  snackbarService = inject(SnackbarService);
  dialog = inject(MatDialog);

  leavingEvaluations = new Set<number>();
  paginatedEvaluations = computed(() => {
    const pageIndex = this.pageIndex();
    const pageSize = this.pageSize();
    const start = pageIndex * pageSize;
    const end = start + pageSize;
    return this.evaluations().slice(start, end);
  });

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }

  confirmDelete(evaluation: Evaluation): void {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      data: { message: `Voulez-vous supprimer l'évaluation n°${evaluation.numEvaluation} ?` }
    });

    ref.afterClosed().subscribe(result => {
      if (result) {
        this.enseignantService.deleteEvaluation(evaluation.idEvaluation, this.idEnseignant()).subscribe({
          next: () => {
            this.leavingEvaluations.add(evaluation.idEvaluation);

            setTimeout(() => {
              this.leavingEvaluations.delete(evaluation.idEvaluation);
              this.deleteEvaluation.emit(evaluation.idEvaluation);
            }, 300);
            this.snackbarService.info(`L'évaluation n°${evaluation.numEvaluation} a été supprimée`);
          },
          error: (err) => {
            this.snackbarService.error(`Échec de la suppression de l'évaluation`);
          }
        });
      }
    });
  }
}
